import { Injectable } from '@angular/core';
import {HttpInterceptor,HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse,HttpRequest, HttpHandler, HttpEvent, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({
      'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class FaqService {
  constructor(private http:HttpClient) { }
  backendUrl = environment.apiURL;
  apiURL=environment.backendurl;
answerid:any;
answertext:any;
previousserchkeyword:any;

  public autoSuggestion(params): Observable<any>
  {
      return this.http.get(`${this.backendUrl}autoSuggest?letter=${params}`);
  }

  public search(letter,page:any,size:any): Observable<any>
  {
  const params = new HttpParams()
.set('keyword',letter)
  .set('page', page)
  .set('size',size)

    return this.http.get(`${this.backendUrl}allAnswersByKeyword?${params}`);
  }

  public popularArticles(page:any,size:any): Observable<any>
  {
    const params = new HttpParams()

    .set('page', page)
    .set('size',size)
    return this.http.get(`${this.backendUrl}popularAnswers?${params}`);
  }
  entityCreate(payload:any):Observable<any> {
    return this.http.post(this.backendUrl+'page/entity/create', payload, httpOptions);
  }
  public allArticles(page:any,size:any):Observable<any>
  {
    const params = new HttpParams()

    .set('page', page)
    .set('size',size)
    return this.http.get(`${this.backendUrl}getAllAnswers?${params}`);
    // return this.http.get("./assets/json/allArticles_Maine.json");
  }
  public getArticlesByKeywords(letter:any,page:any,size:any):Observable<any>
  {
    const params = new HttpParams()
    .set('page', page)
    .set('size',size)
    .set('letter', letter)
    // return this.http.get(`${this.backendUrl}/branch/getBranchDetail/${id}`);
    return this.http.get(`${this.backendUrl}allAnswersByAToZ?${params}`);
  }
  public getArticlesByNumber(params):Observable<any>
  {
    // return this.http.get(`${this.backendUrl}/branch/getBranchDetail/${id}`);
    return this.http.get(`${this.backendUrl}allAnswersByAToZ?letter=${params}`);
  }
  public article(id):Observable<any>
  {
    const params = new HttpParams()
    .set('answerid', id)
    return this.http.get(`${this.backendUrl}allAnswerById?${params}`);
  }
  public getFAQArticles(id):Observable<any>
  {
    return this.http.get(`${this.backendUrl}getFAQArticles?articleid=${id}`);//not using
  }
  public likeArticle(answerFeedbackYes:any) {
    // const formData = {
    //   answerFeedbackYes

    // }
    // return this.httpClient.post(environment.apiURL + 'showLocationFromAddress', formData)

    return this.http.post(`${this.backendUrl}answerFeedbackYes`, answerFeedbackYes);
  }
  public dislikeArticle(answerFeedbackNo:any) {
    return this.http.post(`${this.backendUrl}answerFeedbackNo`, answerFeedbackNo);
  }
  public sendEmailAttachment(params) {
    return this.http.post(environment.apiURL+`sendMail`, params);//not using
    // return this.http.post(`${this.backendUrl}/sendEmailFAQAttachment`, params);
  }
  public getAtoZCount() {
    return this.http.get(`${this.backendUrl}allAnswersByAToZCounts`);
  }


  public getRecentArticles():Observable<any>
  {
    return this.http.get(`${this.backendUrl}getRecentAnswers`);
  }

  sendMessage(payload:any,usermsg:any){
    const headers = new HttpHeaders({
      'Authorization': payload,  // Using payload as the authorization token
      'Content-Type': 'application/json',
    });
    console.log(usermsg);
    console.log(payload);

    return this.http.post(environment.chatbotUrl + 'api/v1/generate', usermsg, { headers});
  }
  submitFeedback(payload:any):Observable<any> {
    return this.http.post(environment.backendurl+"ChatFeedback", payload);
  }
  private handleError(errorObj: HttpErrorResponse | any) {
    const _self = this;
    let errorMessage: string;
    let body: any;
    if (errorObj instanceof HttpErrorResponse) {
      if (errorObj.ok === false && errorObj.status === 0) {
        errorMessage = 'No internet connection or server might be unreachable. Please try again after sometime.';
      } else {
        body = errorObj.error || '';
        errorMessage = body.message ? body.message : body.error.message;
      }
    }
    return throwError(errorMessage);
  }

}
